// extracted by mini-css-extract-plugin
module.exports = {"textGradient":"style_textGradient__ufDUL"};